import {FC} from "react";
import EmployeesPopup from "./EmployeesPopup";
import EventsPopup from "./EventsPopup";
import ApprovePPHPopup from "./ApprovePPHPopup";
import TrucksPopup from "./TrucksPopup";

const PopupsContainer: FC = () => {
    return (
        <>
            <EmployeesPopup />
            <EventsPopup />
            <ApprovePPHPopup />
            <TrucksPopup />
        </>
    )
}

export default PopupsContainer;
